(() => {
  'use strict';
  const key = 'er_google_purchase_ref_v2';
  const attribute = '__er_ads_ref';
  const ttl = 30 * 86400000;
  const eventName = 'ember_rove:google_ads_cart_link';
  const endpoint = "https://bridge-marketing---pixel-collector-a5kj25ftna-uc.a.run.app/events";
  const isInternal = queryInternal();
  const query = new URL(location.href).searchParams;
  const clicks = ['gclid', 'gbraid', 'wbraid'].flatMap(kind =>
    query.getAll(kind).map(value => [kind, value]));
  const paidLanding = clicks.length === 1 && /^[A-Za-z0-9_-]{10,200}$/.test(clicks[0][1]);
  let inFlight = Promise.resolve();
  let lastWritten = '';

  function queryInternal() { return new URL(location.href).searchParams.get('er_analytics_test') === '1'; }

  function permission() {
    const privacy = Shopify.customerPrivacy;
    return typeof privacy?.marketingAllowed === 'function' ? privacy.marketingAllowed() === true : null;
  }

  function otherPermissions() {
    const privacy = Shopify.customerPrivacy;
    const read = method => {
      try {
        const value = privacy?.[method]?.();
        return typeof value === 'boolean' ? value : null;
      } catch (_) { return null; }
    };
    return {consent_analytics: read('analyticsProcessingAllowed'), consent_sale_of_data: read('saleOfDataAllowed')};
  }

  function saved() {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      if (/^[0-9a-f]{32}$/.test(value?.ref) && Number.isSafeInteger(value.at) &&
          value.at <= Date.now()) return value;
    } catch (_) {}
    return null;
  }

  function ref() {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  }

  async function landingFingerprint() {
    const bytes = new TextEncoder().encode(clicks[0].join(':'));
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
  }

  async function setCart(value) {
    const root = new URL(Shopify.routes.root, location.origin);
    if (root.origin !== location.origin) return false;
    const result = await fetch(new URL('cart/update.js', root), {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: {[attribute]: value}})
    });
    if (!result.ok) return false;
    const attributes = (await result.json()).attributes || {};
    return value ? attributes[attribute] === value : !attributes[attribute];
  }

  async function record(entry, click) {
    if (permission() !== true || saved()?.ref !== entry.ref) return false;
    const payload = {
      schema_version: 2, event_id: ref(), event_name: eventName,
      event_timestamp_utc: new Date().toISOString(), shop_domain: location.hostname,
      client_id: entry.clientId, google_ads_ref: entry.ref, link_state: 'linked',
      ...otherPermissions(), consent_marketing: true,
      is_internal: isInternal || entry.internal === true
    };
    if (click) payload[click[0]] = click[1];
    const response = await fetch(endpoint, {
      method: 'POST', credentials: 'omit', keepalive: true,
      headers: {'Content-Type': 'application/json'}, body: JSON.stringify(payload)
    });
    return response.ok;
  }

  async function synchronize() {
    const allowed = permission();
    if (allowed === null) return;
    let entry = saved();
    if (entry && (!allowed || Date.now() - entry.at >= ttl)) {
      if (await setCart('') && saved()?.ref === entry.ref) localStorage.removeItem(key);
      lastWritten = '';
      return;
    }
    if (!allowed) return;
    let click = null;
    if (paidLanding) {
      const fingerprint = await landingFingerprint();
      if (permission() !== true) return;
      entry = saved();
      if (entry?.fingerprint !== fingerprint || !entry.clientId) {
        entry = {ref: ref(), clientId: ref(), at: Date.now(), fingerprint, internal: isInternal};
        localStorage.setItem(key, JSON.stringify(entry));
      }
      if (!entry.clickRecorded) click = clicks[0];
    }
    if (!entry?.clientId) return;
    const writtenState = entry.ref + ':' + JSON.stringify(otherPermissions());
    if (writtenState === lastWritten && !click) return;
    if (await setCart(entry.ref) && permission() === true && saved()?.ref === entry.ref) {
      if (await record(entry, click)) {
        lastWritten = writtenState;
        if (click && permission() === true && saved()?.ref === entry.ref) {
          localStorage.setItem(key, JSON.stringify({...entry, clickRecorded: true}));
        }
      }
    }
  }

  function enqueue() {
    inFlight = inFlight.then(() => {
      return window.navigator?.locks?.request ? window.navigator.locks.request(key, synchronize) : synchronize();
    }).catch(() => {});
  }

  if (!window.Shopify) return;
  document.addEventListener('visitorConsentCollected', enqueue);
  window.addEventListener('pageshow', enqueue);
  if (Shopify.customerPrivacy) enqueue();
  else Shopify.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], err => {
    if (!err) enqueue();
  });
})();
